module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#star",
      toString: function () {
        return this.url;
      }
    }